export default {
  choose_an_option: "Scegli un'opzione:",
  choose_an_option_is_formal: "Scegli un'opzione:",
  select_options: 'Seleziona le opzioni',
  select_options_is_formal: 'Seleziona le opzioni',
  enter_text_here: 'Inserisci qui il testo',
  redirect_counter_message:
    'Ti reindirizzeremo al nostro sito web tra {{counter}} secondi.',
  redirect_counter_message_is_formal:
    'Ti reindirizzeremo al nostro sito web tra {{counter}} secondi.',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  whatsapp: 'WhatsApp',
  sms: 'SMS /iMessage',
  email: 'E-Mail',
  nps_scale_meaning: '0 = improbabile / 10 = molto probabile',
  please_provide_answers_to_both_questions:
    'Si prega di rispondere a entrambe le domande',
  please_answer_the_first_question: 'Si prega di rispondere alla prima domanda',
  please_answer_the_second_question:
    'Si prega di rispondere alla seconda domanda',
  answer_at_least_one_question: 'Si prega di rispondere ad almeno una domanda',
  selection: 'Selezione',
  answer: 'Risposta',
  share_api_option_text: 'Scegli App',
  share_status_SHARE: 'Condiviso',
  share_status_CANCEL: 'Condivisione annullata',
  language_nav_label: 'Selezione della lingua',
  OPENS_IN_NEW_TAB: 'si apre in una nuova scheda',
  nps_rating_aria: 'Valutazione',
  language_switcher_aria: 'Seleziona lingua',
  company_logo_aria: 'Logo aziendale (si apre in una nuova scheda)',
  powered_by_hypt_aria: 'Powered by HYPT (si apre in una nuova scheda)',
  employee_search_placeholder: 'Cerca...',
  employee_search_aria: 'Cerca un dipendente',
  loading_aria: 'Caricamento',
  chat_messages_aria: 'Messaggi della chat',
  skip_to_content: 'Vai al contenuto',
  company_logo_alt: 'Logo aziendale',
  ai_feedback_input_aria: 'Inserisci il tuo feedback',
  error_funnel_not_published: 'Questionario non ancora pubblicato',
  error_funnel_not_found: 'Questo questionario non esiste',
  error_funnel_come_back_later:
    'Per favore torna più tardi. Apprezziamo la tua pazienza.',
  error_404: 'ERRORE 404',
  error_page_not_found: 'PAGINA NON TROVATA',
  chat_history_aria: 'Cronologia chat',
  checkbox_required_sr: 'almeno una selezione richiesta',
  ai_answer_required_hint: 'Inserisci il tuo feedback per continuare'
};
